import { CoralException } from '@ch-types/CoralException';

export default class ValidationException extends CoralException {}
